<template>
    <div class="card-coin">
        <div class="card-coin-price">{{price}}</div>
        <div class="card-coin-img">
            <img src="/assets/images/icons/coin.svg">
            <div class="card-coin-point">{{ point }} Poin</div>
            <div class="card-coin-wrap-button">
                <button v-if="log_total === btnRedeem" class="card-coin-button" @click="openModal">Redeem</button>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" :id="'redeemModal-' + id" tabindex="-1" role="dialog" aria-labelledby="redeemModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <form id="formDelivery" @submit.prevent="handleSubmit">
                        <div class="modal-header">
                            <h5 class="modal-title" id="redeemModalLabel">Redeem {{ point }} Point</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div v-if="loadingVoucher">
                                <div class="text-center">
                                    <pulse-loader color="#EC550E"></pulse-loader>
                                </div>
                            </div>
                            <div v-else>
                                <div class="form-group">
                                    <label >Nama Penerima :</label>
                                    <input type="text" placeholder="Nama Penerima" name="name" v-bind:class="errors.hasOwnProperty('name') ? 'is-invalid' : ''" v-model="name" class="form-control" disabled>
                                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('name')">
                                        {{ errors['name'][0] }}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label >Pilih Jenis Saldo :</label>
                                    <select name="voucher_type" class="form-control" v-bind:class="errors.hasOwnProperty('type_voucher') ? 'is-invalid' : ''" v-model="type_voucher">
                                        <option value="">Pilih Jenis Saldo</option>
                                        <option value="ovo">OVO</option>
                                        <option value="gopay">Gopay</option>
                                        <option value="dana">Dana</option>
                                        <option value="bri">BRI</option>
                                    </select>
                                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('type_voucher')">
                                        {{ errors['type_voucher'][0] }}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>No HP Terdaftar di OVO / GOPAY / DANA / BRI:</label>
                                    <input type="text" placeholder="No HP Terdaftar di OVO / GOPAY / DANA" v-bind:class="errors.hasOwnProperty('phone') ? 'is-invalid' : ''" name="phone" v-model="phone" class="form-control" >
                                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('phone')">
                                        {{ errors['phone'][0] }}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Nama yang Terdaftar di OVO / GOPAY / DANA / BRI:</label>
                                    <input type="text" placeholder="Nama yang Terdaftar di OVO / GOPAY / DANA" name="name_id" v-bind:class="errors.hasOwnProperty('name_id') ? 'is-invalid' : ''" v-model="name_id" class="form-control" >
                                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('name_id')">
                                        {{ errors['name_id'][0] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Redeem</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
    components: {
        PulseLoader
    },
    name: "RedeemCoinCard",
    props: ['id','log_total', 'price', 'point'],
    data() {
        return {
            btnRedeem:0,
            typeVouchers: [],
            type_voucher: '',
            voucher_type:'',
            phone:'',
            name_id:'',
            name: '',
            loadingVoucher: true,
            errors: []
        }
    },
    mounted(){
       if(this.log_total === 0 || this.log_total === null )
       {
         this.btnRedeem = this.log_total;
       }

    },
    methods: {
        openModal() {
            $(`#redeemModal-${this.id}`).modal('show');
            this.getListVoucher(this.id);
        },

        handleSubmit() {
            const self = this;
            self.token = self.$cookies.get('token');
            self.errors = [];
            const data = {
                type_voucher: self.type_voucher,
                phone: self.phone,
                name_id:self.name_id,
                redeem_id: self.id
            }
            axios.post('/api/redeem/take', data, { headers: {"Authorization" : `Bearer ${self.token}`} })
                .then((response) => {
                     self.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    });
                    $(`#redeemModal-${this.id}`).modal('hide');
                    this.$emit('refresh', true)
                })
                .catch((error) => {
                    if(error.response) {
                        this.$notify({
                           duration: 5000,
                           group: 'main',
                           title: 'Oopppss!',
                           text: error.response.data.message,
                           type: 'warn'
                       });
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors;
                        }
                    }
                });
        },
        async getListVoucher(id) {
            this.loadingVoucher = true;
            const token = this.$cookies.get('token');
            await axios.get(`/api/redeem/voucher/`+ id, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.typeVouchers = response.data.list;
                    this.user = response.data.user;
                    this.name = response.data.user.fullname;
                    this.phone = this.user.phone;
                    this.loadingVoucher = false;
                })
                .catch((error) => {

                });
        }
    }
}
</script>

<style scoped>
.card-coin {
    margin: 0 10%;
    text-align: center;
    margin-bottom: 40px;
    border: 1px solid #E0E0E0;
    box-sizing: border-box;
    box-shadow: 0 8px 10px rgb(0 0 0 / 10%);
    border-radius: 10px;
}
.card-coin-price {
    background-color: #C4C4C4;
    padding: 10px;
    border-radius: 10px 10px 0 0;
    font-style: normal;
    font-weight: bold;
    font-size: 23px;
    line-height: 36px;
    color: #333333;
}
.card-coin-img {
    padding: 15px;
    background: #fff;
    border-radius: 0 0 10px 10px;
}
.card-coin-img img {
    width: 100%;
    height: auto;
}
.card-coin-point {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 36px;
    color: #333333;
    margin-top: 5px;
}
.card-coin-button {
    border: 1px solid #4F4F4F;
    box-sizing: border-box;
    border-radius: 35px;
    width: 100px;
    background-color: #fff;
}
.pointer.voucher-wrap {
    padding: 10px;
    border: 1px solid #eee;
    margin-bottom: 5px;
    border-radius: 10px;
}
.pointer.voucher-wrap:hover {
    background-color: #eee;
}
.pointer.voucher-wrap.active {
    background-color: #eee;
}

.text-alert{
    margin: 0px 0px;
    text-align: left;
    position: relative;
    bottom: 13px;
}
.has-error .form-control {
    border-color: #f05050;
    box-shadow: none !important;
}
</style>
